var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.64 20.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff3d00;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.32,
    cy: 10.32,
    r: 10.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.06,13.29c-.12.63-.63,1.11-1.26,1.2-.99.15-2.64.33-4.5.33s-3.48-.18-4.5-.33c-.63-.09-1.14-.57-1.26-1.2-.12-.69-.24-1.71-.24-2.97s.12-2.28.24-2.97c.12-.63.63-1.11,1.26-1.2.99-.15,2.64-.33,4.5-.33s3.48.18,4.5.33c.63.09,1.14.57,1.26,1.2.12.69.27,1.71.27,2.97-.03,1.26-.15,2.28-.27,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.11,12.42v-4.2l3.6,2.1-3.6,2.1h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeicon);
export default __webpack_public_path__ + "static/media/youtubeicon.ac0ee65d4ec698eccf64beb84c88ba37.svg";
export { ForwardRef as ReactComponent };